import { SET_IS_FETCHING_NOTIFICATIONS, SET_NOTIFICATIONS } from 'reducers/actions-types';
import axios from 'axios';
import { dispatchError } from 'reducers/helpers';
import { notifications } from 'constants/api-urls';

export function fetch() {
    return function(dispatch) {
        dispatch({ type: SET_IS_FETCHING_NOTIFICATIONS, isFetching: true });
        axios.get(notifications())
            .then(
                /**
                 * @param {INotification[]} data
                 */
                ({ data }) => {
                    dispatch({ type: SET_IS_FETCHING_NOTIFICATIONS, isFetching: false });
                    dispatch({ type: SET_NOTIFICATIONS, items: data });
                })
            .catch(e => {
                dispatch({ type: SET_IS_FETCHING_NOTIFICATIONS, isFetching: false });
                dispatchError(dispatch, e, {
                    url: notifications(),
                    description: e,
                    reloadButton: true,
                });
            });
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/notifications/helpers.js